import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Users, Quote } from 'lucide-react';
import { images } from '../data/mock';

const Team = () => {
  const { t } = useLanguage();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const teamImages = [
    `${BACKEND_URL}/generated_images/haitian_player_1.png`,
    `${BACKEND_URL}/generated_images/haitian_player_2.png`,
    `${BACKEND_URL}/generated_images/haitian_player_7.png`,
    `${BACKEND_URL}/generated_images/haitian_player_1.png`
  ];

  return (
    <section id="team" className="relative py-24 bg-gradient-to-b from-gray-900 to-gray-950">
      {/* Background Effect */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/30 mb-6">
            <Users className="w-4 h-4 text-blue-400" />
            <span className="text-sm font-medium text-blue-400">Coalition Nationale</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {t.team.title}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
            {t.team.subtitle}
          </p>
          <p className="text-lg text-gray-400 max-w-4xl mx-auto leading-relaxed">
            {t.team.description}
          </p>
        </div>

        {/* Team Composition */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {t.team.roles.map((role, index) => (
            <div
              key={index}
              className="group relative bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6 hover:border-blue-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20 hover:-translate-y-1"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-red-500/0 group-hover:from-blue-500/10 group-hover:to-red-500/10 rounded-xl transition-all duration-300" />
              <div className="relative z-10">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Users className="w-5 h-5 text-white" />
                </div>
                <h4 className="text-lg font-bold text-white">{role}</h4>
              </div>
            </div>
          ))}
        </div>

        {/* Team Image Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-20">
        {teamImages.map((img, index) => (
            <div
              key={index}
              className="relative aspect-square rounded-xl overflow-hidden group cursor-pointer"
            >
              <img
                src={img}
                alt={`Team ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950/80 to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-300" />
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div>
          <h3 className="text-3xl font-bold text-white text-center mb-12">
            {t.testimonials.title}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {t.testimonials.list.map((testimonial, index) => (
              <div
                key={index}
                className="group relative bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-blue-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/20"
              >
                <div className="absolute top-6 right-6 opacity-20 group-hover:opacity-30 transition-opacity duration-300">
                  <Quote className="w-12 h-12 text-blue-500" />
                </div>
                
                <div className="relative z-10">
                  <p className="text-gray-300 italic mb-6 leading-relaxed">
                    "{testimonial.quote}"
                  </p>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-lg">
                        {testimonial.name.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>
                    <div>
                      <div className="font-bold text-white">{testimonial.name}</div>
                      <div className="text-sm text-gray-400">{testimonial.role}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
